import { ApplicationConfig, importProvidersFrom, inject } from '@angular/core';
import { provideRouter } from '@angular/router';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MSAL_INSTANCE, MsalService, MsalGuard, MsalInterceptorConfiguration, MSAL_GUARD_CONFIG, MsalGuardConfiguration, MsalBroadcastService, MsalModule } from '@azure/msal-angular';

import {  } from '@azure/msal-angular';

import { PublicClientApplication, InteractionType } from '@azure/msal-browser';

import { provideZoneChangeDetection } from '@angular/core';
import { routes } from './app.routes';

import { msalConfig } from './auth/auth-config';
import { provideAppInitializer } from '@angular/core';
import { logAccountAndRoles } from './auth/auth-debug';



export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    // ✅ Important: enable interceptors registered via DI (e.g., MsalInterceptor)
    provideHttpClient(withInterceptorsFromDi()),

  
    importProvidersFrom(MsalModule),

    // MSAL INSTANCE
    {
      provide: MSAL_INSTANCE,
      useFactory: () => new PublicClientApplication(msalConfig),
    },

    // MSAL Services
    MsalService,
    MsalGuard,
    MsalBroadcastService,

    // MSAL Guard configuration
    {
      provide: MSAL_GUARD_CONFIG,
      useValue: { interactionType: InteractionType.Redirect } as MsalGuardConfiguration,
    },

    // {
    //   provide: MSAL_INTERCEPTOR_CONFIG,
    //   useFactory: (): MsalInterceptorConfiguration => {
    //     const protectedResourceMap = new Map<string, string[]>();

    //     // Exemplo: sua API
    //     protectedResourceMap.set('https://SEU_DOMINIO_API/', ['api://SEU_API_CLIENT_ID/access_as_user']);
    //     // ou se você já tem isso em environment, monte daqui.

    //     return {
    //       interactionType: InteractionType.Redirect,
    //       protectedResourceMap,
    //     };
    //   },
    // },


    // Register the MSAL interceptor
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: MsalInterceptor,
    //   multi: true,
    // },

    provideAppInitializer(() => {
      const msalService = inject(MsalService);

      return msalService.instance.initialize().then(() => {
        msalService.handleRedirectObservable().subscribe({
          next: (result) => {
            if (result?.account) {
              msalService.instance.setActiveAccount(result.account);
            } else {
              const accounts = msalService.instance.getAllAccounts();
              if (accounts.length > 0) {
                msalService.instance.setActiveAccount(accounts[0]);
              }
            }

            logAccountAndRoles(msalService);

          },
          error: (error) => console.error('MSAL redirect error', error),
        });
      });
    }),


  ],
};